import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://api.shriadithyahospitals.com/",
  // baseURL: "http://192.168.0.241:5678/",
  // timeout: 5000, // Set the timeout for requests (optional)
});

// Add a request interceptor to attach the token from localStorage
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Retrieve the token from localStorage
  if (token) {
    config.headers["Authorization"] = `Token ${token}`; // Add the token to the request headers
  } else {
    delete config.headers["Authorization"]; // Remove Authorization header if no token
  }
  return config;
});

export default axiosInstance;
